import FormElementMixin from '../mixins/FormElementMixin.js';

Vue.asyncComponent('ak-toggle', {
    mixins: [FormElementMixin],
    props: {
        size: {
            type: String,
            required: false
        }
    },
    watch: {
        currentValue(newValue, oldValue) {
            if (newValue !== oldValue) {
                this.$emit('toggle', newValue);
            }
        }
    }
}, 'form/controls/ak-toggle.html');